<template>
  <span class="arrow_1_out"></span>
  <span class="arrow_2_out"></span>
  <span class="arrow_3_out"></span>
  <span class="arrow_4_out"></span>
  <span class="arrow_5_out"></span>
  <span class="arrow_6_out"></span>
  <div style="transition: 0.4s; height:490px; z-index: 200;" :style="usLangMask == 'en-US' ? { width: '500px' } : { width: '320px' }" class="flex-1 bg-white rounded-xl space-y-6 p-6 tip-block" :class="`step_menu`">
    <div>{{block_01}}</div>
    <span class="text-sm text-gray-400">{{describe_01}}</span>
    <hr style="margin:6px 0px; border-top: 1px solid #d1d5db;">
    <div style="margin-top:0px;">{{block_02}}</div>
    <span class="text-sm text-gray-400">{{describe_02}}</span>
    <hr style="margin:6px 0px; border-top: 1px solid #d1d5db;">
    <div style="margin-top:0px;">{{block_03}}</div>
    <span class="text-sm text-gray-400">{{describe_03}}</span>
    <hr style="margin:18px 0px 20px; border-top: 1px solid #d1d5db;">
    <div style="margin-top:0px;">{{block_04}}</div>
    <span class="text-sm text-gray-400">{{describe_04}}</span>
    <hr style="margin:4px 0px; border-top: 1px solid #d1d5db;">
    <div style="margin-top:0px;">{{block_05}}</div>
    <span class="text-sm text-gray-400">{{describe_05}}</span>
    <hr style="margin:4px 0px; border-top: 1px solid #d1d5db;">
    <div style="margin-top:0px;">{{block_06}}</div>
    <span class="text-sm text-gray-400">{{describe_06}}</span>
    <hr style="margin:4px 0px; border-top: 1px solid #d1d5db;">    
    <!-- <div class="tip-footer text-right" style="display: block;"> -->
    <div class="tip-footer">
      <button class="hover:bg-gray-400 focus:outline-none rounded-xl px-4 py-1 mr-2 text-white transition duration-500 ease-in-out border-gray-500 border-2 bg-gray-500" @click="endTeaching()">
        取消教學
      </button>
      <button class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400" @click="end()">
        {{endButton}}
      </button>
    </div>
  </div>
</template>

<script>
// import * as contentData from '@/components/Tips/marketingMethods.json';

export default {
  name: 'HomeMask',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    usLangMask: {
      type: String
    },
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '完成',
      closeTipsText: '跳過教學',
      block_01: '個人資訊卡',
      describe_01: '您所連接的FaceBook用戶帳號',
      block_02: '帳號資訊',
      describe_02: '串接權限、使用方案、付款&發票資訊',
      block_03: '行銷活動列表',
      describe_03: '建立與調整廣告',
      block_04: '分析報表',
      describe_04: 'AI廣告數據、興趣文字雲、數據下載',
      block_05: '教學影片',
      describe_05: '系統操作教學說明',
      block_06: '關於AutoTurn',
      describe_06: '下載系統介紹說明',
      endButton: '知道了',
    }
  },
  computed: {
    // content() {
    //   const data = contentData.default.filter(e => e.step === this.nowStep);
    //   let message;
    //   if (data.length > 0) {
    //     message = data[0].content_zh_TW;
    //     if(this.selectLang == 'en-US'){
    //       this.nextText = 'next';
    //       this.finishText = 'finish';
    //       this.closeTipsText = 'skip teaching';

    //       message = data[0].content_en_US;
    //     }
    //   } else {
    //     message = '';
    //   }
    //   return message;
    // }
  },
  watch:{
    'usLangMask':function(v){
      console.log('HomeMask usLangMask');
      console.log(v);

      if(v == 'zh-CN'){
        this.nextText = '下一步';
        this.finishText = '完成';
        this.closeTipsText = '跳过教学';
        this.block_01 = '个人资讯卡';
        this.describe_01 = '您所连接的FaceBook用户帐号';
        this.block_02 = '帐号资讯';
        this.describe_02 = '串接权限、使用方案、付款&发票资讯';
        this.block_03 = '行销活动列表';
        this.describe_03 = '建立与调整广告';
        this.block_04 = '分析报表';
        this.describe_04 = 'AI广告数据、兴趣文字云、数据下载';
        this.block_05 = '教学影片';
        this.describe_05 = '系统操作教学说明'
        this.block_06 = '关于AutoTurn';
        this.describe_06 = '下载系统介绍说明';
        this.endButton = '知道了';
      }

      if(v == 'en-US'){
        this.nextText = 'Next';
        this.finishText = 'finish';
        this.closeTipsText = 'Skip the tutorial';
        this.block_01 = 'personal information';
        this.describe_01 = 'The Facebook user account you are connected to';
        this.block_02 = 'Account information';
        this.describe_02 = 'Link permissions, usage plans, payment & invoice information';
        this.block_03 = 'List of Marketing Activities';
        this.describe_03 = 'Create and adjust ads';
        this.block_04 = 'Analysis report';
        this.describe_04 = 'AI advertising data, interest word cloud, data download';
        this.block_05 = 'instructional video';
        this.describe_05 = 'System Operation Instructions'
        this.block_06 = 'About AutoTurn';
        this.describe_06 = 'Download system introduction instructions';
        this.endButton = 'Yes';
      }
    }
  },
  methods: {
    end(){
      this.$emit('closeMask', false);
    },
    endTeaching(){
      console.log('home endTeaching');
      this.$emit('closeForTeaching', false);
    }
  }
};

</script>

<style lang="scss">

.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}

.step_menu {
  position: absolute;
  top: 20px;
  left: 80px;
}

.hr_style{
  margin:0px;
  border-top: 1px solid blue;
}

.arrow_1_out{
  width:100px;
  height:40px;
  border-width:25px;
  border-style:solid;
  border-color:transparent #fff transparent transparent ;
  position:absolute;
  top:35px;
  left:-5px;
  z-index:201;
}

.arrow_2_out{
  width:100px;
  height:40px;
  border-width:25px;
  border-style:solid;
  border-color:transparent #fff transparent transparent ;
  position:absolute;
  top:110px;
  left:-5px;
  z-index:201;
}

.arrow_3_out{
  width:100px;
  height:40px;
  border-width:25px;
  border-style:solid;
  border-color:transparent #fff transparent transparent ;
  position:absolute;
  top:165px;
  left:-5px;
  z-index:201;
}

.arrow_4_out{
  width:100px;
  height:40px;
  border-width:25px;
  border-style:solid;
  border-color:transparent #fff transparent transparent ;
  position:absolute;
  top:250px;
  left:-5px;
  z-index:201;
}

.arrow_5_out{
  width:100px;
  height:40px;
  border-width:25px;
  border-style:solid;
  border-color:transparent #fff transparent transparent ;
  position:absolute;
  top:305px;
  left:-5px;
  z-index:201;
}

.arrow_6_out{
  width:100px;
  height:40px;
  border-width:25px;
  border-style:solid;
  border-color:transparent #fff transparent transparent ;
  position:absolute;
  top:360px;
  left:-5px;
  z-index:201;
}

/*.step2 {
  position: absolute;
  top: 33vh;
  left: 26vw;
}*/

/*.step3 {
  position: absolute;
  top: 33vh;
  left: 36vw;
}*/

/*.step4 {
  position: absolute;
  top: 33vh;
  left: 46vw;
}*/

/*.step5 {
  position: absolute;
  top: 33vh;
  left: 56vw;
}*/

/* .step6 {
  position: absolute;
  top: 50vh;
  left: 56vw;
} */

/*.step6 {
  position: absolute;
  top: 28vh;
  left: 34vw;
}*/

.tip-footer {
  /*display: flex;*/
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
